<div [formGroup]="journeyFormGroup" class="d-inline-block w-100 mb-5">
  @if (excludeIntracityConnectionsEnabled) {
    <p class="mb-4"><strong i18n="@@upp.flights.details.intracitySelectHint">Select at least one option</strong></p>
  }
  <label for="flightCategories" class="form-label">
    <ng-container i18n="@@upp.flights.details.journeyTypeLabel">Journey type</ng-container>
    @if (!excludeIntracityConnectionsEnabled) {
      <span class="mandatory ms-1">*</span>
    }
  </label>
  <ama-ng-upp-lookup-select
    id="flightCategories"
    formControlName="flightCategories"
    groupBy="parent"
    [groupValue]="journeyTypesGroupValueFn"
    [selectableGroup]="true"
    [items]="journeyTypesOptions"
    bindValue="value"
    bindLabel="label"
    [multiple]="true"
    notFoundText="No journey type found"
    i18n-notFoundText="@@upp.flights.details.journeyTypeNotFound"
    (closed)="onJourneyFieldTouched()"
  >
  </ama-ng-upp-lookup-select>
  <ama-ng-upp-validation-error-message
    [control]="journeyFormGroup.get('flightCategories')!"
    [messageFunctions]="journeyTypeValidationMessages"
  >
  </ama-ng-upp-validation-error-message>

  @if (excludeIntracityConnectionsEnabled) {
    <div class="mt-5 form-check">
      <input
        class="form-check-input"
        name="intracity"
        type="checkbox"
        id="intracity"
        formControlName="intracity"
        [readonly]="readonly"
        (blur)="onJourneyFieldTouched()"
      />
      <label class="form-check-label" for="intracity">
        <span
          i18n="@@upp.flights.details.intracityLabel"
          ngbTooltip="Activate this option to exclude connections between airports within the same city"
          i18n-ngbTooltip="@@upp.flights.details.intracityTooltip"
          >Exclude intracity connections</span
        >
      </label>
    </div>
  }
</div>
